// extracted by mini-css-extract-plugin
export default {"component":"TopStuff_component__M9znQ","subContainer":"TopStuff_subContainer__VoseS"};